import './StickyNav.css'

export default () => {
  if(window.location.hash) {
    const dom = document.querySelector('html');
    const elStickyNavLinks = document.querySelector('[data-jump-nav-links]');
    const windowStyles = window.getComputedStyle(dom);
    const headerHeight = parseInt(windowStyles.getPropertyValue('--header-height'));
    const headerOldHeight = parseInt(windowStyles.getPropertyValue('--header-old-height'));
    const stickyNavHeight = elStickyNavLinks.clientHeight;
    const hash = window.location.hash;
    
    const offset = () => {
      let offset = 0;
      
      if(headerHeight || headerOldHeight) {
        if(headerHeight) {
          offset = offset + headerHeight
        } else {
          offset = offset + headerOldHeight
        }
      }

      if(stickyNavHeight) {
        offset = offset + stickyNavHeight
      }

      return offset
    }
    
    const section = document.querySelector(`${hash}`);
    window.scrollTo(0, section.offsetTop - offset() )
  }
}
